interface ParticipantLike {
  id?: string | null;
  learner_user_id?: string | null;
  external_user_id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
}

const FIRST_NAMES = [
  'Mika',
  'Lina',
  'Noah',
  'Emil',
  'Mila',
  'Nora',
  'Levi',
  'Juna',
  'Theo',
  'Lio',
  'Ella',
  'Finn',
  'Mara',
  'Ben',
  'Leni',
  'Oskar',
];

const LAST_NAMES = [
  'Sommer',
  'Berg',
  'Wagner',
  'Keller',
  'Fischer',
  'Schneider',
  'Meyer',
  'Hoffmann',
  'Becker',
  'Weber',
  'Richter',
  'Klein',
  'Wolf',
  'Schulz',
  'Koch',
  'Braun',
];

function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = Math.imul(31, hash) + value.charCodeAt(i);
  }
  return Math.abs(hash);
}

export function participantPseudonym(participant: ParticipantLike): string {
  const existingName = `${participant.first_name ?? ''} ${participant.last_name ?? ''}`.trim();
  if (existingName) return existingName;

  const seed =
    participant.learner_user_id ||
    participant.external_user_id ||
    participant.id ||
    participant.email ||
    'anonymous-learner';
  const hash = hashString(seed);
  const firstName = FIRST_NAMES[hash % FIRST_NAMES.length];
  const lastName = LAST_NAMES[Math.floor(hash / FIRST_NAMES.length) % LAST_NAMES.length];
  return `${firstName} ${lastName}`;
}
